<template>
	<div>
		<el-container>
			<el-main>
				<el-dialog title="新增诗词" :visible.sync="dialogFormVisible" style="width: 100%">
					<el-form :model="form" class="custom-form">
						<el-form-item label="诗词内容" :label-width="formLabelWidth" class="form-item">
							<el-input type="textarea" v-model="form.poetryText" autocomplete="off" :rows="5" :cols="30" style="width: 100%"></el-input>
						</el-form-item>
					</el-form>
					<div slot="footer" class="dialog-footer">
						<el-button @click="dialogFormVisible = false">取 消</el-button>
						<el-button type="primary" @click="handleConfirm(0)">确 定</el-button>
					</div>
				</el-dialog>
				<el-dialog class="red-title" :visible.sync="dialogMutiFormVisible">
					<div class="red-title" slot="title">批量新增诗词内容(多个诗词换行填写)</div>
					<el-form :model="form" class="custom-form">
						<el-form-item label="诗词内容" :label-width="formLabelWidth" class="form-item">
							<el-input type="textarea" v-model="form.poetryText" autocomplete="off" :rows="5" :cols="30" style="width: 100%"></el-input>
						</el-form-item>
					</el-form>
					<div slot="footer" class="dialog-footer">
						<el-button @click="dialogMutiFormVisible = false">取 消</el-button>
						<el-button type="primary" @click="handleConfirm(1)">确 定</el-button>
					</div>
				</el-dialog>
				<el-dialog title="随机一诗词" :visible.sync="randomFormVisible" style="width: 100%">
					<el-descriptions class="margin-top" title="随机选择的诗词如下:" :column="3" border>
						<el-descriptions-item v-model="randomAlgorithmic.poetryText">
							<template slot="label">诗词内容</template>
							{{ randomAlgorithmic.poetryText }}
						</el-descriptions-item>
					</el-descriptions>
					<div slot="footer" class="dialog-footer">
						<el-button @click="randomFormVisible = false">取 消</el-button>
					</div>
				</el-dialog>
				<el-form :inline="true" :model="formInline" class="demo-form-inline">
					<el-form-item>
						<el-input clearable v-model="formInline.poetryText" placeholder="请输入问题" @keydown.enter.native="interviewPage"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="interviewPage">查询</el-button>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="prepareRandom">随机诗词</el-button>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="prepareAdd">新增</el-button>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="prepareMutiAdd">批量新增</el-button>
					</el-form-item>
				</el-form>
				<el-table border :data="algorithmicList" v-loading="loading">
					<el-table-column prop="id" label="序号" width="80" sortable></el-table-column>
					<el-table-column prop="poetryText" label="内容" show-overflow-tooltip></el-table-column>
					<el-table-column label="创建时间" width="170">
						<template slot-scope="props">
							{{ props.row.createTime | dateFormat }}
						</template>
					</el-table-column>
					<el-table-column prop="操作" label="操作" width="180">
						<template slot-scope="props">
							<el-button type="success" @click.prevent="preEdit(props.row.id, props.row.poetryText)" width="200">编辑</el-button>
							<el-dialog title="编辑算法问题" :visible.sync="editVisible">
								<el-form :model="form">
									<el-form-item label="内容" :label-width="formLabelWidth" class="form-item">
										<el-input type="textarea" v-model="form.poetryText" autocomplete="off" :rows="5" :cols="30" style="width: 100%"></el-input>
									</el-form-item>
								</el-form>
								<div slot="footer" class="dialog-footer">
									<el-button @click="editVisible = false">取 消</el-button>
									<el-button type="primary" @click="editConfirm">确 定</el-button>
								</div>
							</el-dialog>
							<el-button type="danger" @click="prepareDelete(props.row.id)">删除</el-button>
							<el-dialog title="提示" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
								<span>确认删除吗</span>
								<span slot="footer" class="dialog-footer">
									<el-button @click="dialogVisible = false">取 消</el-button>
									<el-button type="primary" @click.prevent="onDelete(currentRowId)">确 定</el-button>
								</span>
							</el-dialog>
						</template>
					</el-table-column>
				</el-table>
				<el-pagination class="pagination" background :key="elementui_page_component_key" :current-page.sync="currentPage" :page-size="pageSize" :total="total" @current-change="handleCurrentChange"></el-pagination>
			</el-main>
			<el-backtop class="backtop"></el-backtop>
		</el-container>
	</div>
</template>

<script>
import axios from 'axios'
export default {
	name: 'MyInterview',

	data() {
		return {
			// 用户列表数据
			algorithmicList: [],
			randomAlgorithmic: {
				poetryText: '',
			},
			loading: false,
			elementui_page_component_key: 0,
			currentPage: Number(localStorage.getItem('poetryLastPage')) || 1,
			pageSize: 9,
			total: 0,
			formInline: {
				poetryText: '',
			},
			// 新增的内容
			dialogFormVisible: false,
			randomFormVisible: false,
			dialogMutiFormVisible: false,
			form: {
				poetryText: '',
			},
			formLabelWidth: '120px',
			dialogVisible: false,
			editVisible: false,
			currentRowId: null,
		}
	},
	watch: {
		'formInline.poetryText'(newVal, oldVal) {
			if (newVal !== oldVal) {
				this.currentPage = 1
				localStorage.setItem('poetryLastPage', this.currentPage)
				this.interviewPage()
			}
		},
		// 监听currentPage的变化，将新值保存到localStorage中
		currentPage(newPage) {
			localStorage.setItem('poetryLastPage', newPage.toString())
		},
	},
	created() {
		//获取问题类型的枚举
		this.interviewPage()
	},
	mounted() {
		this.currentPage = 1
	},
	methods: {
		prepareAdd() {
			this.form.poetryText = ''
			this.dialogFormVisible = true
		},
		prepareRandom() {
			this.randomAlgorithmic = []
			this.randomFormVisible = true
			this.interviewRandom()
		},
		prepareMutiAdd() {
			this.form.poetryText = ''

			this.dialogMutiFormVisible = true
		},

		prepareDelete(id) {
			this.currentRowId = id
			this.dialogVisible = true
		},
		preEdit(id, poetryText) {
			this.form.poetryText = poetryText
			this.currentRowId = id
			this.editVisible = true
		},
		handleClose(done) {
			this.$confirm('确认关闭？')
				.then((_) => {
					done()
				})
				.catch((_) => {})
		},
		handleConfirm(addType) {
			this.dialogFormVisible = false // 关闭对话框
			this.dialogMutiFormVisible = false
			this.addQuestion(addType) // 发送请求
		},

		async addQuestion(addType) {
			try {
				this.loading = true
				const { data: res } = await axios.post('http://43.139.90.182:8888/aphorismPoetry/add', {
					addType: addType,
					poetryText: this.form.poetryText,

					degreeOfImportance: this.form.degreeOfImportance,
					degreeOfDifficulty: this.form.degreeOfDifficulty,
					difficultyOfScore: this.form.difficultyOfScore,
					leetcodeNumber: this.form.leetcodeNumber,
					leetcodeLink: this.form.leetcodeLink,
				})
				if (res.code === 200) {
					this.form.poetryText = ''
					this.currentPage = 1
					this.interviewPage()
				} else {
					console.error('Received non-200 status code', res)
					this.errorMsg(res.message)
				}
			} catch (error) {
				console.error('An error occurred while adding the poetryText:', error)
				// 异常处理逻辑
			} finally {
				this.loading = false
			}
		},
		errorMsg(msg) {
			this.$message({
				showClose: true,
				message: msg,
				type: 'error',
			})
		},
		async editConfirm() {
			try {
				this.loading = true
				const { data: res } = await axios.post('http://43.139.90.182:8888/aphorismPoetry/update', {
					id: this.currentRowId,
					poetryText: this.form.poetryText,
				})
				if (res.code === 200) {
					this.form.poetryText = ''
					this.editVisible = false
					currentRowId: null
					this.interviewPage()
				} else {
					console.error('Received non-200 status code', res)
				}
			} catch (error) {
				console.error('An error occurred while adding the poetryText:', error)
				// 异常处理逻辑
			} finally {
				this.loading = false
			}
		},

		async onDelete(id) {
			this.dialogVisible = false
			this.loading = true
			const { data: res } = await axios.get('http://43.139.90.182:8888/aphorismPoetry/delete', {
				params: {
					id: id,
				},
			})
			this.interviewPage()
			this.loading = false
		},
		refreshPage() {
			//获取问题类型的枚举
			this.interviewPage()
			location.reload()
		},
		async interviewPage() {
			this.loading = true
			const { data: res } = await axios.get('http://43.139.90.182:8888/aphorismPoetry/page', {
				params: {
					page: this.currentPage,
					pageSize: this.pageSize,
					poetryText: this.formInline.poetryText,
				},
			})
			if (res.code === 200) {
				this.total = res.result.totalElements
				this.algorithmicList = res.result.content
			}
			this.loading = false
		},
		async interviewRandom() {
			this.loading = true
			const { data: res } = await axios.get('http://43.139.90.182:8888/aphorismPoetry/random', { params: {} })
			if (res.code === 200) {
				this.randomAlgorithmic.poetryText = res.result.poetryText
			}
			this.loading = false
		},
		handleCurrentChange(currentPage) {
			this.currentPage = currentPage
			this.interviewPage()
		},
	},
}
</script>

<style lang="less" scoped>
.el-header {
	background-color: #b3c0d1;
	color: #333;
	line-height: 60px;
}

.el-aside {
	color: #333;
}

.pagination {
	margin-top: 16px;
	text-align: right;
}
.header-button-item {
	margin-right: 15px;
	font-size: 20px;
}

.red-title {
	line-height: 24px;
	font-size: 18px;
	color: red;
}

.backtop {
	position: fixed;
	bottom: 50px;
	right: 50px;
	height: 40px;
	width: 40px;
	line-height: 40px;
	text-align: center;
	border-radius: 20px;
	background-color: #007aff;
	color: #fff;
	cursor: pointer;
	z-index: 999;
}
.custom-textarea {
	width: 100%;
	text-align: left;
}

.backtop:hover {
	background-color: #0050a0;
}
</style>